export const LIMIT = {
  SEARCH_LIMIT: 50,
  MAX_UPLOAD_SIZE: 150 * 1024 * 1024, // 150MB
  MIN_PASS_LENGTH: 6,
  MAX_PASS_ATTEMPTS: 3,
  MAX_NOTIFICATION_QUEUE_SIZE: 2, // max notification stack size for displaying
  NOTIFICATION_POLING_MS: 1 * 60 * 1000, // 1 min
  LEADER_CHANNEL_NAME: 'notification_leader',
  DATA_CHANNEL_NAME: 'notification_data',
  LEADER_HEARTBEAT_MS: 5000,
  LEADER_TIMEOUT_MS: 15000
};
